/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { StoresActions, StoresActionType } from '../actions/storesActions';
import { StoresListItemDto, StoresListFilterParams } from '../api/stores/storesClientTypings';
import { StoresListTableData } from '../../components/RegistryWidgets/Stores/StoresList/StoresListConfig';
import { getPageLimitByScreenSize } from '../../utils/utils';

export const defaultSearchType: keyof StoresListTableData = 'taxNumber';

export interface StoresState {
    storesList: StoresListItemDto[];
    limit: number;
    afterKey: string;
    lastRequestItemsCount: number;
    filterParams: StoresListFilterParams;
    changedFilterParams: StoresListFilterParams;
    isLoading: boolean;
}

const initialState: StoresState = {
    storesList: [],
    limit: getPageLimitByScreenSize(),
    afterKey: null,
    lastRequestItemsCount: null,
    filterParams: {
        search_type: defaultSearchType,
        search_text: '',
        statuses: [],
        storeTypes: [],
        taxationTypes: [],
        taxAuthorityIds: [],
        fromCashBoxesCount: null,
        toCashBoxesCount: null,
        inspectedFromDateUtc: null,
        inspectedToDateUtc: null,
        inspectionStatuses: [],
        inspectionResults: [],
        regionCodes: [],
    },
    changedFilterParams: null,
    isLoading: false,
};

function storesReducer(state: StoresState = initialState, action: StoresActions): StoresState {
    switch (action.type) {
        case StoresActionType.OPEN_REGISTRY_STORES_LIST_PAGE:
            return {
                ...state,
            };

        case StoresActionType.FETCH_NEXT_PAGE_START:
            return {
                ...state,
                isLoading: true,
                changedFilterParams: null,
            };

        case StoresActionType.APPLY_FILTERS:
            return {
                ...state,
                isLoading: true,

                storesList: [],
                afterKey: null,
                lastRequestItemsCount: null,

                filterParams: state.changedFilterParams ? { ...state.changedFilterParams } : { ...state.filterParams },
                changedFilterParams: null,
            };

        case StoresActionType.CHANGE_FILTERS:
            return {
                ...state,
                changedFilterParams: action.payload,
            };

        case StoresActionType.FETCH_STORES_LIST_SUCCESS:
            const combinedList: StoresListItemDto[] = [...state.storesList];

            if (action.payload.list.stores && action.payload.list.stores.length > 0) {
                combinedList.push(...action.payload.list.stores);
            }

            return {
                ...state,
                isLoading: false,
                storesList: combinedList,
                afterKey: action.payload.list.afterKey,
                lastRequestItemsCount: action.payload.list.stores.length,
            };

        case StoresActionType.FETCH_STORES_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case StoresActionType.DOWNLOAD_EXCEL:
            return {
                ...state,
                isLoading: true,
                changedFilterParams: null,
            };

        case StoresActionType.DOWNLOAD_EXCEL_SUCCESS:
        case StoresActionType.DOWNLOAD_EXCEL_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case StoresActionType.EXIT_REGISTRY_STORES_LIST_PAGE:
            return {
                ...state,
                changedFilterParams: null,
            };

        default:
            return state;
    }
}

export default storesReducer;
